import React from 'react';
import { FaPhone } from 'react-icons/fa6';
import * as S from '../sipstyles/SipWebClient.style';
import WebMuteComponent from './WebMuteComponent';
import WebSpeakerComponent from './WebSpeakerComponent';

interface KeypadProps {
  phoneNumber: string;
  callStatus: 'idle' | 'dialing' | 'connected' | 'ended' | 'ringing';
  onKeypad: (key: string) => void;
  onDial: () => void;
  onBackspace: () => void;
  onBackspaceAll: () => void;
  onEndCall: () => void;
  onRejectCall: () => void;
  onAcceptCall: () => void;
  environmentS: string;
}

const WebKeypad = ({
  phoneNumber,
  callStatus,
  onDial,
  onBackspace,
  onEndCall,
  onRejectCall,
  onAcceptCall,
  environmentS,
}: KeypadProps) => {
  return (
    <S.KeypadContainer>
      {callStatus === 'ringing' ? (
        <>
          <S.EndCallButton onClick={onRejectCall}>
            <FaPhone />
          </S.EndCallButton>
          <S.SwipeCallWrap>
            <S.SwipeCallSpan />
          </S.SwipeCallWrap>
          <S.CallButton className="show" onClick={onAcceptCall}>
            <FaPhone />
          </S.CallButton>
        </>
      ) : (
        <S.KeypadCallButtonWrap>
          {(callStatus === 'dialing' || callStatus === 'connected') && (
            <>
              <S.EndCallButton onClick={onEndCall}>
                <FaPhone />
              </S.EndCallButton>
              {environmentS === 'app' && <WebSpeakerComponent />}
            </>
          )}
          {callStatus === 'connected' && <WebMuteComponent />}
          {callStatus === 'idle' && (
            <S.CallButton onClick={onDial} disabled={!phoneNumber}>
              <FaPhone />
            </S.CallButton>
          )}
        </S.KeypadCallButtonWrap>
      )}
    </S.KeypadContainer>
  );
};

export default WebKeypad;
